import { render, staticRenderFns } from "./heybox-logo.vue?vue&type=template&id=6121f920&scoped=true"
import script from "./heybox-logo.vue?vue&type=script&lang=js"
export * from "./heybox-logo.vue?vue&type=script&lang=js"
import style0 from "./heybox-logo.vue?vue&type=style&index=0&id=6121f920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_3juzzlkbpjdftz5heowg2t23qe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6121f920",
  null
  
)

export default component.exports